import React from 'react';
import QuicksightWorkbenchComponent from 'components/workbench/QuicksightWorkbenchComponent';

class DataLoadingDashboardOverview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.quicksightWorkbenchRef = React.createRef();
    }

    render() {
        let dashboard = (
            <div>
                <QuicksightWorkbenchComponent
                    ref={this.quicksightWorkbenchRef}
                    key="quick-sight-workbench-data-loading-dashboard"
                    tenantId={this.props.tenantId}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    path={this.props.path}
                    forceLoad={true}
                    iFrameHeight="850px"
                    iFrameWidth="100%"
                    dropdownClassPrefix="select-long"
                    tabFunction={this.props.tabFunction}
                    loadDataOnMount={true}
                    {...this.props}
                />
            </div>
        );

        return <div>{dashboard}</div>;
    }
}

export default DataLoadingDashboardOverview;
